import { render, staticRenderFns } from "./PerformerEventsShow.vue?vue&type=template&id=0419f496&scoped=true&"
import script from "./PerformerEventsShow.vue?vue&type=script&lang=js&"
export * from "./PerformerEventsShow.vue?vue&type=script&lang=js&"
import style0 from "./PerformerEventsShow.vue?vue&type=style&index=0&id=0419f496&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0419f496",
  null
  
)

export default component.exports